import { http, reduxHttpMiddlewareFactory } from "rd-redux-http";
import { apiUrl, prepareRequest, customFetch } from "../utils";
import { ChartDataResponse } from "./api";
import { saga } from "../withSaga";

const rmw = reduxHttpMiddlewareFactory();

export interface ReportDataRequestParams {
    campaignId: string;
    timezone: string;
    fromDate?: string;
    toDate?: string;
}

export interface ReportDataWithMetricsRequestParams extends ReportDataRequestParams {
    metrics: string[];
}

export function createReportDataWithDynamicMetricsRequest(dimensions?: string[]) {
    const convertParams = createDynamicMetricsParameterConverter(dimensions);

    return saga.withSaga(
        rmw.register(
            http
                .get<ReportDataWithMetricsRequestParams>(apiUrl("reporting/data/:campaignId"), true)
                .prepareParams(convertParams)
                .pre(prepareRequest)
                .withFetch(customFetch)
                .resultFromJson<ChartDataResponse>()
                // .convertResult<ChartDataResponse>(async response => {
                //     const result: ChartDataResponse = await response.json();

                //     return {
                //         dimensions: result.dimensions,
                //         metrics: result.metrics.map<ChartMetricData>(m => ({
                //             bins: m.bins,
                //             metric: m.metric,
                //             data: []
                //         }))
                //     } as ChartDataResponse;
                // })
                .build()
        )
    );
}

interface ChartDataRequest {
    dimensions?: string[];
    metrics?: string[];
    from?: string;
    to?: string;
}

type ChartDataRequestParams = ChartDataRequest & { campaignId: string; timezone: string };

function createDynamicMetricsParameterConverter(
    dimensions: string[]
): ((params: ReportDataWithMetricsRequestParams) => any) {
    return function convertParams(params: ReportDataWithMetricsRequestParams): any {
        const result: { [P in keyof ChartDataRequestParams]?: string } = {};
        result.campaignId = params.campaignId;
        result.timezone = params.timezone;

        if (params.fromDate) {
            result.from = params.fromDate;
        }
        if (params.toDate) {
            result.to = params.toDate;
        }

        if (params.metrics && params.metrics.length) {
            result.metrics = params.metrics.join("|");
        }

        if (dimensions && dimensions.length) {
            result.dimensions = dimensions.join("|");
        }

        return result;
    };
}
